<template>
  <div class="login-container d-flex justify-content-center align-items-center min-vh-100 bg-light">
    <form @submit.prevent="loginSubmit" class="login-form p-4 rounded-4  bg-white shadow-lg">
      <div class="bg-secondary p-1 rounded-4 ">
        <img src="@/assets/images/logo.png" alt="Logo" class="logo img-fluid rounded" style="margin-right: 30px;" />
      </div>

      <div class="mb-3 mt-3">
        <label for="username" class="form-label">نام کاربری</label>
        <input
            v-model="form.username"
            type="text"
            id="username"
            class="form-control"
            :class="{ 'is-invalid': errors.username }"
            placeholder="نام کاربری خود را وارد کنید"
        />
        <div v-if="errors.username" class="invalid-feedback d-block">{{ errors.username }}</div>
      </div>

      <div class="mb-3">
        <label for="password" class="form-label">رمز عبور</label>
        <div class="input-group">
          <input
              v-model="form.password"
              :type="passwordVisible ? 'text' : 'password'"
              id="password"
              class="form-control"
              :class="{ 'is-invalid': errors.password }"
              placeholder="رمز عبور خود را وارد کنید"
          />
          <button type="button" @click="togglePasswordVisibility" class="btn btn-secondary" style="height: 33px; border: transparent">
            <i :class="passwordVisible ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
          </button>
        </div>
        <div v-if="errors.password" class="invalid-feedback d-block">{{ errors.password }}</div>
      </div>

      <div class="mb-3 form-check">
        <input type="checkbox" v-model="form.rememberMe" class="form-check-input" id="rememberMe"/>
        <label class="form-check-label" for="rememberMe">مرا به خاطر بسپار</label>
      </div>

      <div v-if="errorMessage" class="alert alert-danger text-center">{{ errorMessage }}</div>

      <button type="submit" class="btn btn-primary w-100" :disabled="isLoading">
        <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span v-else>ورود</span>
      </button>
    </form>
  </div>
</template>

<script>
import { ref, reactive } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import axios from "../../node_modules/axios/dist/axios";

export default {
  setup() {
    const store = useStore()
    const router = useRouter()

    const form = reactive({
      username: '',
      password: '',
      rememberMe: false
    })

    const errors = reactive({})
    const errorMessage = ref('')
    const isLoading = ref(false)
    const passwordVisible = ref(false)

    const validateForm = () => {
      errors.username = form.username.trim() === '' ? 'نام کاربری نمی‌تواند خالی باشد' :
          form.username.length < 5 ? 'نام کاربری باید حداقل 5 کاراکتر باشد' : ''
      errors.password = form.password.trim() === '' ? 'رمز عبور نمی‌تواند خالی باشد' :
          form.password.length < 8 ? 'رمز عبور باید حداقل 8 کاراکتر باشد' : ''
      return !errors.username && !errors.password
    }

    const checkInternetConnection = async () => {

      try {
        await fetch('https://api.nikted.ir', {
          mode: 'no-cors',
          cache: 'no-store'
        });
        return true;
      } catch (error) {
        console.error('Internet connection check failed:', error);
        return false;
      }
    }

    const loginSubmit = async () => {
      if (!validateForm()) return

      isLoading.value = true
      errorMessage.value = ''

      try {
        const isOnline = await checkInternetConnection();
        if (!isOnline) {
          errorMessage.value = 'دسترسی شما به اینترنت محدود شده است !'
          return;
        }

        const response = await axios.post('/api/users/login', {
          username: form.username,
          password: form.password
        })
        store.commit('logIn', response.data.token)
        store.commit('userRoleUpdate', response.data.role)
        router.push(`/${response.data.role}`)
      } catch (error) {
        errorMessage.value = error.response.data.error
      } finally {
        isLoading.value = false
      }
    }

    const togglePasswordVisibility = () => {
      passwordVisible.value = !passwordVisible.value
    }

    return {
      form,
      errors,
      errorMessage,
      isLoading,
      passwordVisible,
      loginSubmit,
      togglePasswordVisibility
    }
  }
}
</script>

<style scoped>
.login-container {
  background: radial-gradient(circle, #ffffff 15%, #20abc8 100%);
}
</style>